import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import HotArticles from './components/HotArticles';
import EditorReview from './components/EditorReview';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      {/* SEO Schema.org - WebSite + Organization */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '51吃瓜爆料网',
            url: 'https://51chigua.com',
            description: '51吃瓜爆料网今日吃瓜热门大瓜持续更新，明星塌房内幕、网红翻车实锤证据、娱乐八卦独家深扒，全网首发高清图文视频资源。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://51chigua.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '51吃瓜爆料网',
            url: 'https://51chigua.com',
            description: '国内领先的娱乐八卦资讯聚合平台，秉持"吃瓜无罪，八卦有理"的理念。',
            sameAs: [],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '51吃瓜爆料网 - 今日吃瓜热门大瓜',
            description: '51吃瓜爆料网今日吃瓜热门大瓜持续更新，明星塌房内幕、网红翻车实锤证据、娱乐八卦独家深扒。',
            url: 'https://51chigua.com',
            isPartOf: {
              '@type': 'WebSite',
              name: '51吃瓜爆料网',
            },
          }),
        }}
      />

      <Navbar transparent />

      <main>
        {/* Hero */}
        <HeroSection />

        {/* Category Grid */}
        <CategoryGrid />

        {/* Hot Articles */}
        <HotArticles />

        {/* Editor Review */}
        <EditorReview />

        {/* CTA */}
        <CTASection />
      </main>

      <Footer />
    </>
  );
}